var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"rect-loading",rawName:"v-rect-loading",value:(_vm.loading),expression:"loading"}],staticClass:"other-sync-count-container"},[_c('CounterList',{staticClass:"other",attrs:{"titleI18nKey":`${_vm.i18nPrefix}.label.otherSync`,"data":_vm.otherCountData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }